(function () {
  'use strict';

  function sectionIds() {
    return Array.prototype.slice
      .call(document.querySelectorAll('cart-items-component[data-section-id]'))
      .map(function (el) { return el.dataset.sectionId; })
      .filter(Boolean);
  }

  function toggle(btn) {
    var item = btn.closest('.mnk-ctl__item');
    var panel = item && item.querySelector('.mnk-ctl__variants');
    if (!panel) return;
    var abierto = !panel.hidden;
    panel.hidden = abierto;
    btn.setAttribute('aria-expanded', String(!abierto));
    btn.textContent = abierto ? 'Elegir' : 'Cerrar';
  }

  function add(btn) {
    var id = btn.dataset.mnkAdd;
    var original = btn.textContent;
    var ids = sectionIds();
    btn.disabled = true;
    btn.textContent = '...';

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(id), quantity: 1 }],
        sections: ids,
        sections_url: window.location.pathname
      })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed');
        return res.json();
      })
      .then(function (data) {
        return fetch(window.Shopify.routes.root + 'cart.js')
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (cart) {
            var evt = new Event('cart:update', { bubbles: true });
            evt.detail = {
              resource: cart,
              sourceId: 'mnk-cross-sell',
              data: {
                source: 'mnk-cross-sell',
                itemCount: cart ? cart.item_count : undefined,
                variantId: String(id),
                sections: data.sections || {}
              }
            };
            document.dispatchEvent(evt);
          });
      })
      .then(function () {
        btn.textContent = 'Agregado';
        setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1500);
      })
      .catch(function () {
        btn.textContent = 'Reintenta';
        setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1500);
      });
  }

  // Delegación global: sobrevive a cualquier re-render del carrito.
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-mnk-toggle]');
    if (t) return toggle(t);
    var a = e.target.closest && e.target.closest('[data-mnk-add]');
    if (a) add(a);
  });
})();
